export default __webpack_public_path__ + "static/011-249447c725a25cbfdd18f33f36ee958e.jpg";